import Dexie, { type Table } from 'dexie'
import type { FsrsKarte, EvaluationEvent } from '../types'

export class KlaviermodulDB extends Dexie {
  fsrsKarten!: Table<FsrsKarte, string>
  events!: Table<EvaluationEvent, number>

  constructor() {
    super('xalento-klaviermodul')
    this.version(1).stores({
      fsrsKarten: 'id, uebungsabschnittId, due, state',
      events: '++id, uebungsabschnittId, zeitpunkt, modus',
    })
  }
}

export const db = new KlaviermodulDB()

export async function holeOderErzeugeKarte(
  uebungsabschnittId: string,
  factory: () => FsrsKarte
): Promise<FsrsKarte> {
  const existing = await db.fsrsKarten.get(uebungsabschnittId)
  if (existing) return existing
  const karte = factory()
  await db.fsrsKarten.put(karte)
  return karte
}

export async function speichereKarte(karte: FsrsKarte): Promise<void> {
  await db.fsrsKarten.put(karte)
}

export async function ladeAlleKarten(): Promise<FsrsKarte[]> {
  return db.fsrsKarten.toArray()
}

export async function ladeFaelligeKarten(): Promise<FsrsKarte[]> {
  const jetzt = Date.now()
  return db.fsrsKarten.where('due').belowOrEqual(jetzt).toArray()
}

export async function protokolliereEvent(event: EvaluationEvent): Promise<void> {
  await db.events.add(event)
}

export async function ladeEventsFuer(uebungsabschnittId: string): Promise<EvaluationEvent[]> {
  return db.events.where('uebungsabschnittId').equals(uebungsabschnittId).toArray()
}
